
<template>
  <div>
    <v-layout wrap>
      <vue-element-loading
        :active="appLoading"
        :is-full-screen="true"
        background-color="#FFFFFF"
        color="#FDAC53"
        spinner="bar-fade-scale"
      />
    </v-layout>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-img
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.9) "
          width="100%"
          height="400px"
          src="../../assets/images/slider1.png"
          class="align-center"
        >
          <v-layout wrap>
            <v-flex xs12 text-center class="play">
              Direct from Hivekeepers
            </v-flex>
          </v-layout>
        </v-img>
      </v-flex>
      <v-flex xs12 class="hidden-md-and-up">
        <v-layout wrap pt-7 pa-3 justify-center>
          <v-flex xs12 sm7>
            <v-text-field outlined dense label="Pin" class="textfd">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm7>
            <v-text-field outlined dense label="State"> </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-layout wrap justify-center>
              <v-flex sm2>
                <span>10km</span>
              </v-flex>
              <v-flex text-center sm3>
                <span>Radius</span>
              </v-flex>
              <v-flex text-right sm2> 250km </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm7>
            <v-slider
              color="#FEBD08"
              :value="sliderValue"
              v-model="sliderValue"
              thumb-label
              track-color="grey"
              max="250"
              min="10"
            >
            </v-slider>
          </v-flex>
          <v-flex sm7>
            <v-btn width="100%" color="#FEBD08" @click="changeSlider">
              Search
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-center class="head" pt-md-16> Beekeepers </v-flex>
      <v-flex xxs12 text-center style="font-family: robotoregular; color: grey"
        >Near by
      </v-flex>
      <v-flex xs12 v-if="bee.length < 1" text-center class="RB" py-5>
        No Result Found...!</v-flex
      >
      <v-flex xs12 px-lg-12 v-else>
        <v-layout wrap px-md-12>
          <v-flex xs6 sm6 md4 lg3 v-for="(item, i) in bee" :key="i" pa-7>
            <v-card tile elevation="6" height="220px">
              <v-layout wrap pa-5>
                <v-flex xs4 sm4 md4 lg4 v-if="item.sellerProfileId.hiveGallery">
                  <v-avatar
                    ><v-img
                      :src="mediaURL + item.sellerProfileId.hiveGallery[0]"
                    ></v-img>
                  </v-avatar>
                </v-flex>
                <v-flex xs6 sm6 sm8 md8 lg8 pb-3 pl-3 pl-sm-0>
                  <span style="font-family: robotomedium">{{
                    item.sellerProfileId.displayName
                  }}</span>
                  <br />
                  <span style="font: 14 px robotoregular; color: grey"
                    >{{ item.sellerProfileId.distance }} Km</span
                  >
                </v-flex>
                <v-flex xs10 style="font: 14px robotoregular">
                  {{ item.sellerProfileId.heading }}
                </v-flex>
                <!-- <v-flex xs12 text-left> -->
                <v-layout wrap justify-start>
                  <v-flex xs10 sm10 md10 lg10>
                    <v-rating
                      size="13"
                      color="#FDC944"
                      background-color="#C7BCBC"
                      :value="parseFloat(item.sellerProfileId.rating)"
                    >
                    </v-rating>
                  </v-flex>
                  <v-flex xs2 sm2 md2 lg2
                    >{{ item.sellerProfileId.rating }}
                  </v-flex>
                </v-layout>
                <!-- </v-flex> -->
                <v-flex xs12 pt-5>
                  <router-link
                    style="text-decoration: none; color: black"
                    :to="'/beekeeperProducts/' + item._id"
                  >
                    <v-btn width="100%" tile color="black">
                      <span style="color: white"> VIEW PRODUCTS </span>
                    </v-btn>
                  </router-link></v-flex
                >
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 pb-5>
            <v-pagination
              color="#FEBD08"
              v-model="currentPage"
              :length="pages"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <div
        :class="
          $vuetify.breakpoint.name == 'md'
            ? 'headd2 hidden-sm-and-down'
            : 'headd hidden-sm-and-down'
        "
      >
        <v-card tile>
          <v-layout wrap>
            <v-flex pl-5 xs3 pt-1>
              <span style="color: #8e8e8e">State</span>
              <v-select
                :items="states"
                v-model="state"
                class="textfd pt-3"
                dense
              >
              </v-select>
            </v-flex>
            <v-flex px-2 xs3 pt-1>
              <span style="color: #8e8e8e">Pin</span>
              <v-text-field v-model="pincode" class="textfd pt-3" dense>
              </v-text-field>
            </v-flex>
            <v-flex xs3 pt-1>
              <span style="color: #8e8e8e">Radius</span>
              <v-layout justify-center wrap>
                <v-flex xs6>
                  <span style="color: #898080; font-size: 10px">10 KM</span>
                </v-flex>
                <v-flex xs6 text-right>
                  <span style="color: #898080; font-size: 10px">250 KM</span>
                </v-flex>
              </v-layout>
              <!-- <v-text-field class="textfd" dense>
            </v-text-field> -->
              <v-slider
                color="#FEBD08"
                :value="sliderValue"
                v-model="sliderValue"
                thumb-label
                track-color="grey"
                max="250"
                min="10"
              >
              </v-slider>
            </v-flex>
            <v-flex pl-2 pr-5 xs3 align-self-center>
              <v-btn
                width="100%"
                tile
                @click="changeSlider"
                background-color="#8E8E8E"
                color="#FEBD08"
              >
                Search
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      states: [],
      pincode: null,
      state: null,
      sliderValue: null,
      hover: false,
      page: null,
      currentPage: 1,
      pages: 0,
      count: 16,
      totalData: 0,
      appLoading: false,
      ServerError: false,
      bee: [],
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getStates();
  },
  methods: {
    changeSlider() {
      if (this.state == "All") {
        this.getData();
      } else {
        this.appLoading = true;
        axios({
          method: "GET",
          url: "/beekeepers/getlist",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params: {
            count: this.count,
            page: this.currentPage,
            min_km: 0,
            max_km: this.sliderValue,
            state: this.state,
            pincode: this.pincode,
          },
        })
          .then((response) => {
            this.appLoading = false;
            this.bee = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/beekeepers/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          // min_km:0,
          // max_km:this.sliderValue
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.bee = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getStates() {
      this.states.push("All");
      axios({
        method: "GET",
        url: "/states/getlist",
        // headers: {
        //   "x-auth-token": localStorage.getItem("token"),
        // },
      }).then((response) => {
        if (response.data.status) {
          for (let i = 0; i < response.data.data.length; i++) {
            this.states.push(response.data.data[i].state);
          }
        } else {
          console.log("failed to get the states");
        }
      });
    },
  },
};
</script>
<style scoped>
.headd {
  position: absolute;
  top: 490px;
  left: 17%;
  right: 17%;
}
.headd2 {
  position: absolute;
  top: 18.5%;
  left: 20%;
}
.headd3 {
  position: absolute;
  top: 24.5%;
  left: 33%;
}
.headd4 {
  position: absolute;
  top: 24.5%;
  left: 33%;
}
</style>